/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import Modal from "react-modal";

const modalStyle = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    border: "none",
    background: "transparent",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "var(--component-color-material-dimmer)",
    zIndex: 1000,
  },
};
Modal.setAppElement("#root");

type Props = {
  modalIsOpen: boolean;
  closeModal: () => void;
  onChange?: () => void;
  title?: string;
  content?: JSX.Element | string;
  btnTitle?: string;
};

const MemberDeleteModal = (props: Props) => {
  const { modalIsOpen, closeModal, onChange, title, content, btnTitle } = props;

  return (
    <Modal isOpen={modalIsOpen} onRequestClose={closeModal} style={modalStyle}>
      <Container>
        <CancelIcon>
          <UI.IconButton.Normal
            type="primary"
            icon="x"
            size={20}
            color="var(--alias-color-label-normal)"
            onClick={closeModal}
          />
        </CancelIcon>
        <CautionIcon>
          <UI.Icon name="inform" size={56} color="var(--alias-color-status-negative)" />
        </CautionIcon>
        <UI.Typography
          type="heading01"
          fontStyle="bold"
          color="var(--alias-color-label-normal)"
          style={{ marginTop: "16px", wordBreak: "break-word" }}
        >
          {title}
        </UI.Typography>
        <UI.Typography
          type="body01 normal"
          fontStyle="medium"
          color="var(--alias-color-label-alternative)"
          style={{ marginTop: "16px", wordBreak: "break-word" }}
        >
          {content}
        </UI.Typography>
        <ButtonContainer>
          <UI.Button
            type="outlined"
            title="취소하기"
            size="large"
            primary={true}
            style={{ width: "100%" }}
            onClick={closeModal}
          />
          <UI.Button
            type="solid"
            title="삭제하기"
            size="large"
            primary={true}
            style={{ width: "100%" }}
            onClick={onChange}
          />
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

export default MemberDeleteModal;

const Container = styled.div`
  width: 454px;
  padding: 48px;
  box-sizing: border-box;
  background-color: white;
  box-shadow: var(--alias-style-shadow-heavy);
  border-radius: 20px;
  position: relative;
  align-items: center;
  text-align: center;
`;

const CancelIcon = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  cursor: pointer;
`;

const CautionIcon = styled.div`
  box-shadow: 0px 0px 40px 0px rgba(255, 62, 62, 0.4);
  width: 47px;
  height: 47px;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 40px;
`;
